import type { IconDefinition } from '../index.tsx';

export const iconCheckCircle: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconCheckCircle',
  icon: [
    16,
    16,
    [],
    '',
    'M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM12.7071 5.70711L11.2929 4.29289L6.5 9.08579L4.70711 7.29289L3.29289 8.70711L6.5 11.9142L12.7071 5.70711Z',
  ],
  fillRule: 'evenodd',
  clipRule: 'evenodd',
};
